import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import deferEditionModalParameters from './src/__generated__/DeferEditionModalComponentQuery$parameters';

type EntryPointParams = {
	cloudId: string;
	productKey: string;
};

export const jiraDeferEditionModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(async () =>
		import(
			/* webpackChunkName: "async-jira-defer-edition-modal" */ './src/DeferEditionModalComponent.tsx'
		).then(({ DeferEditionModalComponent }) => DeferEditionModalComponent),
	),
	getPreloadProps: ({ cloudId, productKey }: EntryPointParams) => ({
		queries: {
			deferEditionModal: {
				parameters: deferEditionModalParameters,
				variables: { cloudId, productKey },
			},
		},
	}),
});
